import React, {
	memo,
	useCallback,
	useMemo
} from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

import styles from '../table.module.css';

// This is a custom filter UI for selecting
// a unique option from a list
const TagsColumnFilter = ( {
	column: {
		filterValue,
		id,
		preFilteredRows,
		setFilter,
		setTableState
	}
} ) => {
	// Calculate the options for filtering
	//  using the preFilteredRows
	const options = React.useMemo( () => {
		const options = [];

		preFilteredRows.forEach( row => {
			row.values[ id ].forEach( value => {
				if ( !options.find( option => option.id === value.id ) ) {
					options.push( value );
				}
			} );
		} );

		return options;
	}, [
		id,
		preFilteredRows
	] );

	const mapOptions = () => options.map( ( option, i ) => {
		return {
			key: i + 1,
			text: option.text,
			color: option.color,
			value: option.text
		};
	} );

	const handleChange = useCallback( ( e, { value } ) => {
		setTableState
			? setTableState( prev => {
				const filters = prev.filters?.length
					? prev.filters.filter( col => col.id !== id )
					: [];

				return {
					...prev,
					filters: value
						? [
							...filters,
							{ id, value }
						]
						: filters
				};
			} )
			: setFilter( value || [] );
	}, [
		id,
		setFilter,
		setTableState
	] );

	const renderLabel = ( {
		color,
		text
	} ) => ( {
		content: text,
		style: {
			backgroundColor: color,
			boxShadow: 'none',
			color: '#fff'
		}
	} );

	const value = useMemo( () => filterValue || [], [ filterValue ] );

	// Render a multi-select box
	return (
		<>
			<Dropdown
				className={ styles.multiSelectFilter }
				clearable
				closeOnChange
				fluid
				multiple
				onChange={ handleChange }
				options={ mapOptions() }
				renderLabel={ renderLabel }
				selection
				value={ value }
			/>
		</>
	);
};

TagsColumnFilter.propTypes = {
	column: PropTypes.shape( {
		filterValue: PropTypes.array,
		id: PropTypes.string,
		preFilteredRows: PropTypes.array,
		setFilter: PropTypes.func,
		setTableState: PropTypes.func
	} )
};

export default memo( TagsColumnFilter );
